import { render, staticRenderFns } from "./company-social-media-information.vue?vue&type=template&id=06d009b9&"
import script from "./company-social-media-information.vue?vue&type=script&lang=js&"
export * from "./company-social-media-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports